import React from "react";
import { ToolbarProps, Navigate } from "react-big-calendar";
import { Button } from "../../../design/button";
import { ChevronLeftIcon } from "@heroicons/react/20/solid";
import { ChevronRightIcon } from "@heroicons/react/16/solid";

const ChangeViewComponent: React.FC<ToolbarProps<object>> = (props) => {
  return (
    <div className="flex items-center gap-2">
      {/* Previous Button */}
      <Button 
        key={Navigate.PREVIOUS} 
        outline 
        onClick={() => props.onNavigate(Navigate.PREVIOUS)}
        aria-label="Go to previous period"
        className="p-2"
      >
        <ChevronLeftIcon className="w-4 h-4" />
      </Button>
      
      {/* Today Button */}
      <Button 
        key={Navigate.TODAY} 
        outline 
        onClick={() => props.onNavigate(Navigate.TODAY)}
        aria-label="Go to today"
        className="px-4 py-2"
      >
        Today
      </Button>
      
      {/* Next Button */}
      <Button 
        key={Navigate.NEXT} 
        outline 
        onClick={() => props.onNavigate(Navigate.NEXT)}
        aria-label="Go to next period"
        className="p-2"
      >
        <ChevronRightIcon className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default ChangeViewComponent;
